/*eslint-disable no-console*/
import axios from "axios";
import { endpoint } from "../../config/app.config";
import ReactGA from "react-ga";
import resources from "../../config/content/searchPage";
import { clearCookie, getCookie, setParentDomainCookie } from "../../utils/cookies";
const { googleAnalytics : {search_txt}} = resources;
ReactGA.set({ anonymizeIp: true });
const GADegrees = ["MD/DO", "NP/APN", "RPh/PharmD", "PA", "RN", "NE", "PT"];
const { token, reset, sub, user } = getCookie()

export const getSearchResult = ({ userInput, termInput, from, degree, description, sessionId, aId, fromOprx, fromAds = false, fromHcpPopup}) => {
  // const query = termInput ? termInput.length > 0 ? `${userInput} ${termInput}` : userInput : userInput;
  const query = (userInput.trim().replaceAll("|", " ")) + (termInput.trim().length > 0 ? " " : "") + termInput.trim();
  let degreeRole = degree;
  if (degree.toLowerCase().includes("patient") || degree.toLowerCase().includes("consumer") || degree.toLowerCase().includes("caregiver")) {
    degreeRole = "PT"
  }
  const location = JSON.parse(localStorage.getItem("phactmi-bounded-user"))
  let headers;
  if (!location["lat"]) {
    headers = {
      ip: location
    }
  } else {
    headers = {
      lat: location.lat,
      long: location.lon
    }
  }
  clearCookie()
  return axios
    .get(`${endpoint}/api/search/substances`, {
      params: {
        query: userInput.trim(),
        term: termInput.trim(),
        from,
        degreeRole,
        description,
        sessionId,
        aId,
        degree: (degreeRole === "PT"|| degreeRole === "NE") ? "patient" : degreeRole
      },
      headers: headers,
      withCredentials: false
    })
    .then((response) => {
      setParentDomainCookie(token, reset, sub, user)
      let companyName = "";
      window.dataLayer = window.dataLayer || [];
      if (response && response.data && response.data.spl && response.data.searchResults) {
        response.data.spl.forEach((ele) => {
          if (!companyName.includes(ele.producer))
            companyName = companyName + (companyName.length > 0 ? " " : "") + ele.producer;
        });
        if (GADegrees.includes(degreeRole)) {
          if (fromAds) {
            window.dataLayer.push({
              event: "PhactMI Custom Event",
              phactmiEventData: {
                "eventCategory": !fromHcpPopup ? "" : degreeRole,
                "eventAction": "aanpwidgetsearch", // redirect from aanp ads
                "eventLabel": query.trim(),
                "cd1": !fromHcpPopup ? "" : degreeRole,
                "cd2": "aanpwidgetsearch", // redirect from aanp ads
                "cd3": userInput.trim(), // drug name
                "cd4": query.trim(),
                "cd6": `${response.data.spl.length}`,
                "cd7": `${response.data.searchResults.length}`,
                "cd8": "Null",
                "cd5": companyName.trim(),
                "cd16": termInput.trim()
              }
            })
          } else {
            window.dataLayer.push({
              event: "PhactMI Custom Event",
              phactmiEventData: {
                "eventCategory": !fromHcpPopup ? "" : degreeRole,
                "eventAction": search_txt,
                "eventLabel": query.trim(),
                "cd1": !fromHcpPopup ? "" : degreeRole,
                "cd2": search_txt,
                "cd3": query.trim(),
                "cd6": `${response.data.spl.length}`,
                "cd7": `${response.data.searchResults.length}`,
                "cd8": "Null",
                "cd5": companyName.trim()
              }
            })
          }
        }
        else {
          if (fromAds) {
            window.dataLayer.push({
              event: "PhactMI Custom Event",
              phactmiEventData: {
                "eventCategory": !fromHcpPopup ? "" : degree,
                "eventAction": "aanpwidgetsearch", // redirect from aanp ads
                "eventLabel": query.trim(),
                "cd1": "Other",
                "cd2": "aanpwidgetsearch", // redirect from aanp ads
                "cd3": userInput.trim(), // drug name
                "cd4": query.trim(),
                "cd6": `${response.data.spl.length}`,
                "cd7": `${response.data.searchResults.length}`,
                "cd8": "Null",
                "cd5": companyName.trim(),
                "cd16": termInput.trim()
              }
            })
          } else {
            window.dataLayer.push({
              event: "PhactMI Custom Event",
              phactmiEventData: {
                "eventCategory": !fromHcpPopup ? "" : degree,
                "eventAction": search_txt,
                "eventLabel": query.trim(),
                "cd1": "Other",
                "cd2": search_txt,
                "cd3": query.trim(),
                "cd6": `${response.data.spl.length}`,
                "cd7": `${response.data.searchResults.length}`,
                "cd8": degree,
                "cd5": companyName.trim()
              }
            })
          }
        }
      }
      return response.data;
    })
    .catch((err) => {
      window.dataLayer = window.dataLayer || [];
      if (GADegrees.includes(degreeRole)) {
        if (fromAds) {
          window.dataLayer.push({
            event: "PhactMI Custom Event",
            phactmiEventData: {
              "eventCategory":!fromHcpPopup ? "" : degreeRole,
              "eventAction": "aanpwidgetsearch", // redirect from aanp ads
              "eventLabel": query.trim(),
              "cd1": !fromHcpPopup ? "" : degreeRole,
              "cd2": "aanpwidgetsearch", // redirect from aanp ads
              "cd3": userInput.trim(), // drug name
              "cd4": query.trim(),
              "cd6": "0",
              "cd7": "0",
              "cd8": "Null",
              "cd16": termInput.trim()
            }
          })
        } else {
          window.dataLayer.push({
            event: "PhactMI Custom Event",
            phactmiEventData: {
              "eventCategory": !fromHcpPopup ? "" : degreeRole,
              "eventAction": search_txt,
              "eventLabel": query.trim(),
              "cd1": !fromHcpPopup ? "" : degreeRole,
              "cd2": search_txt,
              "cd3": query.trim(),
              "cd6": "0",
              "cd7": "0",
              "cd8": "Null"
            }
          })
        }
      }
      else {
        if (fromAds) {
          window.dataLayer.push({
            event: "PhactMI Custom Event",
            phactmiEventData: {
              "eventCategory":!fromHcpPopup ? "" : degree,
              "eventAction": "aanpwidgetsearch", // redirect from aanp ads
              "eventLabel": query.trim(),
              "cd1": "Other",
              "cd2": "aanpwidgetsearch", // redirect from aanp ads
              "cd3": userInput.trim(), // drug name
              "cd4": query.trim(),
              "cd6": "0",
              "cd7": "0",
              "cd8": "Null",
              "cd16": termInput.trim()
            }
          })
        } else {
          window.dataLayer.push({
            event: "PhactMI Custom Event",
            phactmiEventData: {
              "eventCategory": !fromHcpPopup ? "" : degree,
              "eventAction": search_txt,
              "eventLabel": query.trim(),
              "cd1": "Other",
              "cd2": search_txt,
              "cd3": query.trim(),
              "cd6": "0",
              "cd7": "0",
              "cd8": degree
            }
          })
        }
      }
      throw err;
    });
};

export const getProductDetails = ({ productId, degree, description, sessionId, version }) => {
  clearCookie()
  return axios
    .get(`${endpoint}/api/search/spl/${productId}`, {
      params: {
        degree,
        description,
        sessionId,
        version
      },
      withCredentials: false
    })
    .then((response) => {
      setParentDomainCookie(token, reset, sub, user)
      return response.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getManufacturerDetails = () => {
  clearCookie()
  return axios
    .get(`${endpoint}/api/manufacturer`, { withCredentials: false })
    .then((response) => {
      setParentDomainCookie(token, reset, sub, user)
      return response.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getSummary = ({summaryUrl}) => {
  clearCookie()
  return axios
    .get(`${endpoint}/api/search${summaryUrl}`, { withCredentials: false })
    .then((response) => {
      setParentDomainCookie(token, reset, sub, user)
      return response.data;
    })
    .catch((err) => {
      throw err;
    })
}

export const getSectionNameUsingDataCode = () => {
  clearCookie()
  return axios
    .get(`${endpoint}/api/sectionheading`, { withCredentials: false })
    .then((response) => {
      setParentDomainCookie(token, reset, sub, user)
      return response.data
    })
    .catch((err) => {
      throw err;
    });
}
